import React from "react";
import { ReactFlowCanvasContextActions } from "../ReactFlowCanvasContextActions";

export function useReactFlowCanvasActions() {
  return React.useContext(ReactFlowCanvasContextActions);
}
